import { LinkHash } from '@/components/common/Link'
import { ScrollOverflow } from '@/components/common/ScrollOverflow'
import { cn } from '@/utils/commonUtil'

import styles from './JumpHeader.module.scss'

type Props = {
  activeSlug?: string
  items: {
    label: string
    slug?: string
    variant?: 'bold'
  }[]
  offset?: number
}

export const JumpHeader = ({ activeSlug, items, offset }: Props) => (
  <div className={styles.container}>
    <ScrollOverflow activeKey={activeSlug} fadeSize='sm' offset={offset}>
      <ul className={styles.list}>
        {items.map(({ label, slug, variant }, i) => (
          <li key={i}>
            {slug ? (
              <LinkHash
                className={cn(styles.item, { isSelected: slug === activeSlug, styles, variant })}
                data-scroll-active={slug === activeSlug || undefined}
                hash={slug}
              >
                <span>{label}</span>
              </LinkHash>
            ) : (
              <span className={cn(styles.item, { styles, variant })}>{label}</span>
            )}
          </li>
        ))}
      </ul>
    </ScrollOverflow>
  </div>
)
